/* eslint-disable */
import Vue from "vue";

export const MaxLength = {
    bind: function (el, binding, vnode) {
        var value = binding.value;
        var defaultLength = 30;
        el.setAttribute("maxlength", typeof (value) !== 'undefined' ? value : defaultLength);
    }
};

Vue.directive('max-length', MaxLength);